import dagreLayout from './layout'

export const layout = dagreLayout
export default {
  layout: dagreLayout
}

